export default __webpack_public_path__ + "static/media/jordan-sancho.d29b6ca4.jpg";